export const kpis = [
  { label: 'মোট প্রসিকিউশন নোটিশ', value: 25480, key: 'total' },
  { label: 'স্ক্যান/আপলোড সম্পন্ন', value: 23950, key: 'scanned' },
  { label: 'AI/OCR প্রক্রিয়াকৃত', value: 23500, key: 'ocr' },
  { label: 'যাচাইকৃত', value: 22800, key: 'validated' },
  { label: 'অনুমোদনের অপেক্ষায়', value: 700, key: 'pending' },
  { label: 'QR নোটিশ তৈরি', value: 22200, key: 'qr' },
  { label: 'ডাকযোগে প্রেরিত', value: 21500, key: 'dispatched' },
  { label: 'নাগরিক যাচাই', value: 18750, key: 'citizen' },
  { label: 'সন্দেহজনক নোটিশ রিপোর্ট', value: 85, key: 'fraud' }
];

export const monthlyProcessing = [
  { month: 'জানু', received: 2650, processed: 2480, dispatched: 2300 },
  { month: 'ফেব্রু', received: 2820, processed: 2700, dispatched: 2560 },
  { month: 'মার্চ', received: 3010, processed: 2860, dispatched: 2710 },
  { month: 'এপ্রিল', received: 2760, processed: 2690, dispatched: 2590 },
  { month: 'মে', received: 3240, processed: 3080, dispatched: 2950 },
  { month: 'জুন', received: 3460, processed: 3270, dispatched: 3120 },
  { month: 'জুলাই', received: 3580, processed: 3420, dispatched: 3260 },
  { month: 'আগস্ট', received: 3960, processed: 3500, dispatched: 3010 }
];

export const ocrQuality = [
  { name: 'স্বয়ংক্রিয় সফল', value: 19740, color: '#16834A' },
  { name: 'পর্যালোচনা সারি', value: 3290, color: '#E69A20' },
  { name: 'পুনরায় OCR', value: 470, color: '#D93036' }
];

export const approvalStatus = [
  { name: 'অনুমোদিত', value: 22100 },
  { name: 'অপেক্ষমাণ', value: 700 },
  { name: 'ফেরত', value: 410 },
  { name: 'প্রত্যাখ্যাত', value: 120 }
];

export const dispatchStatus = [
  { name: 'প্রেরিত', value: 21500, color: '#006A4E' },
  { name: 'প্রিন্টকৃত', value: 420, color: '#1769AA' },
  { name: 'প্রিন্ট অপেক্ষমাণ', value: 280, color: '#E69A20' }
];

export const verificationTrend = [
  { day: '০৭/১০', qr: 520, manual: 140 },
  { day: '০৮/১০', qr: 610, manual: 155 },
  { day: '০৯/১০', qr: 580, manual: 132 },
  { day: '১০/১০', qr: 690, manual: 170 },
  { day: '১১/১০', qr: 740, manual: 181 },
  { day: '১২/১০', qr: 705, manual: 166 },
  { day: '১৩/১০', qr: 812, manual: 190 }
];

export const fraudByCategory = [
  { name: 'ভুয়া SMS', value: 38, color: '#D93036' },
  { name: 'সন্দেহজনক পেমেন্ট লিংক', value: 21, color: '#E69A20' },
  { name: 'জাল নোটিশ', value: 12, color: '#003B71' },
  { name: 'তথ্য অমিল', value: 9, color: '#1769AA' },
  { name: 'অন্যান্য', value: 5, color: '#94A3B8' }
];

export const divisionProcessing = [
  { division: 'রমনা', processed: 3120, pending: 90 },
  { division: 'লালবাগ', processed: 2210, pending: 70 },
  { division: 'মতিঝিল', processed: 2890, pending: 85 },
  { division: 'ওয়ারী', processed: 1980, pending: 60 },
  { division: 'তেজগাঁও', processed: 4150, pending: 130 },
  { division: 'গুলশান', processed: 3740, pending: 110 },
  { division: 'মিরপুর', processed: 2860, pending: 80 },
  { division: 'উত্তরা', processed: 2850, pending: 75 }
];

export const recentVerifications = [
  { time: '১৩/১০/২০২৬, ১১:৪২', ref: 'DMP-2025-061400748', method: 'QR', result: 'যাচাইকৃত' },
  { time: '১৩/১০/২০২৬, ১১:৩৮', ref: 'DMP/AI/2025/0612/0659', method: 'ম্যানুয়াল', result: 'যাচাইকৃত' },
  { time: '১৩/১০/২০২৬, ১১:৩১', ref: 'অজানা টোকেন', method: 'QR', result: 'অবৈধ' },
  { time: '১৩/১০/২০২৬, ১১:২৬', ref: 'DMP/AI/2025/0612/0644', method: 'QR', result: 'প্রতিস্থাপিত' },
  { time: '১৩/১০/২০২৬, ১১:১৯', ref: 'DMP-2025-061300688', method: 'QR', result: 'যাচাইকৃত' }
];
